import {inject, TaskQueue} from 'aurelia-framework';
import Backend from "../backend";
import {UserInfoProvider} from "../util/user-info-provider";
import isMobile from "ismobilejs";

@inject(Backend, UserInfoProvider, TaskQueue)
export class Home {
  showGrid = false
  backend;
  userInfoProvider;
  taskQueue;

  iconKey = 'bread';
  crateChoiceModalComponentRef;

  constructor(backend, userInfoProvider, taskQueue) {
    this.backend = backend;
    this.userInfoProvider = userInfoProvider;
    this.taskQueue = taskQueue;
  }

  activate(params) {
    this.showSectionMarkers = params.showSectionMarkers;
    return Promise.all([
      this.backend.CrateCatalogQueryHandler_handleV2({onlyFeatured2: true})
        .then(result => {
          this.crateProducts = result.items
        }),
      this.backend.CmsFragmentPublicQueryHandler_handle({items: [
            {cmsFragmentKey: "home__section1_image", imgWidth: 1920}, // used for mobile only. See usage in markup
            {cmsFragmentKey: "home__section1_video"},
            {cmsFragmentKey: "home__section1_html"},
            {cmsFragmentKey: "home__section2_html"},
            {cmsFragmentKey: "home__section3_html"},
            {cmsFragmentKey: "home__section3_1_html"},
            {cmsFragmentKey: "home__section3_2_html"},
            {cmsFragmentKey: "home__section3_3_html"},
            {cmsFragmentKey: "home__section3_1_image"},
            {cmsFragmentKey: "home__section3_2_image"},
            {cmsFragmentKey: "home__section3_3_image"},
            {cmsFragmentKey: "home__section4_html"},
            {cmsFragmentKey: "home__section5_html"},
            {cmsFragmentKey: "home__section5_image", imgWidth: 750},
            {cmsFragmentKey: "home__section6_html"},
            {cmsFragmentKey: "home__section6_image", imgWidth: 750},
            {cmsFragmentKey: "home__section7_html"},
            {cmsFragmentKey: "home__section8_image", imgWidth: 750},
            {cmsFragmentKey: "home__section8_html"},
            {cmsFragmentKey: "home__section9_html"},
            {cmsFragmentKey: "home__section10_html"},
          ]})
        .then(result => {
          this.cmsFragments = result;
        }),
      this.backend.NewsItemQueryHandler_handle({limit: 1})
        .then(result => this.newsItem = result.items[0]),
    ]);
  }

  buy(product) {
    const chosenProducts = [
      {
        productId: product.productId,
        quantity: 1
      }
    ];
    // Show crate choice modal
    this.taskQueue.queueMicroTask({
      call: () => {
        this.crateChoiceModalComponentRef.show(chosenProducts);
      }
    });
  }

  get isMobile() {
    return isMobile().phone;
  }
}
